import { type FC, useCallback, useId } from 'react';
import {
  MEETING_ACCESS_POLICY_TITLE,
  type MeetingTypeVariant,
} from '../../../../utils/meetingAccessPolicy';
import type { MeetingSecuritySectionProps } from '../../types';
import MeetingSecurityOptions from './MeetingSecurityOptions';

const MeetingSecuritySection: FC<MeetingSecuritySectionProps> = ({
  selectedMeetingData,
  isUpdating,
  updateMeetingData,
}) => {
  const baseId = useId();

  const handleMeetingTypeChange = useCallback(
    (meetingType: MeetingTypeVariant) => {
      void updateMeetingData((prev) => ({ ...prev, meetingType }), {
        field: 'meetingType',
        successMessage: `${MEETING_ACCESS_POLICY_TITLE} updated`,
      });
    },
    [updateMeetingData],
  );

  return (
    <MeetingSecurityOptions
      baseId={baseId}
      meetingType={selectedMeetingData.meetingType}
      isUpdating={isUpdating}
      onMeetingTypeChange={handleMeetingTypeChange}
    />
  );
};

export default MeetingSecuritySection;
